import { CONSTANTS, VERTICALS } from "./app-constant";

export const QUALITATIVE_CHART_TYPE_FILTERS = [
  {
    id: 0,
    label: "Ranking",
    value: "Ranking",
  },
  {
    id: 1,
    label: "Trend",
    value: "Trend",
  },
  {
    id: 2,
    label: "Tonality",
    value: "Tonality",
  },
  {
    id: 3,
    label: "SOV",
    value: "SOV",
  },
];

export const PRINT_SOURCE_LIST = [
  {
    id: "Author",
    text: "Author",
  },
  {
    id: "Journalist",
    text: "Journalist",
  },
  {
    id: "Agency",
    text: "News Agency",
  },
];

export const ONLINE_SOURCE_LIST = [
  {
    id: "Agency",
    text: "News Agency",
  },
  {
    id: "Online_Journalist",
    text: "Online Journalist",
  },
];

export const ALL_SOURCE_LIST = [
  ...PRINT_SOURCE_LIST,
  {
    id: "Online",
    text: "Online Journalist",
  },
];

export const SOCIAL_SOURCES = {
  FACEBOOK: 1,
  INSTAGRAM: 2,
  TWITTER: 3,
  YOUTUBE: 4,
  PINTEREST: 7,
  LINKEDIN: 10,
};

export const SOCIAL_SOURCES_OPTIONS = [
  {
    id: SOCIAL_SOURCES.FACEBOOK,
    label: "Facebook",
    value: SOCIAL_SOURCES.FACEBOOK,
    plotOnGraph: true,
    showInShareRetweet : true,
    showInReplyComment: true,
    showInAttachment: true,
    showInTypePost: true,
  },
  {
    id: SOCIAL_SOURCES.INSTAGRAM,
    label: "Instagram",
    value: SOCIAL_SOURCES.INSTAGRAM,
    plotOnGraph: true,
    showInTypePost: true,
    showInShareRetweet: false,
    showInReplyComment: true,
  },
  // {
  //   id: SOCIAL_SOURCES.PINTEREST,
  //   label: "Pinterest",
  //   value: SOCIAL_SOURCES.PINTEREST,
  //   plotOnGraph: true,
  // },
  {
    id: SOCIAL_SOURCES.TWITTER,
    label: "X",
    value: SOCIAL_SOURCES.TWITTER,
    plotOnGraph: true,
    showInShareRetweet : true,
    showInTypePost: true,
    showInShareRetweet: true,
    showInReplyComment: true,
  },
  {
    id: SOCIAL_SOURCES.YOUTUBE,
    label: "Youtube",
    value: SOCIAL_SOURCES.YOUTUBE,
    plotOnGraph: false,
  },
  {
    id: SOCIAL_SOURCES.LINKEDIN,
    label: "LinkedIn",
    value: SOCIAL_SOURCES.LINKEDIN,
    plotOnGraph: false,
    showInShareRetweet : true,
    showInTypePost: false,
    showInShareRetweet: true,
    showInReplyComment: true,
    showInAttachment: true,
    showInMemberType: true,
  },
];

export const TONALITY_FILTER = {
  name: "TONALITY_MULT",
  values: CONSTANTS.TONALITY,
  multiselect: true,
};
export const SOCIAL_TONALITY_FILTER = {
  name: "TONALITY_MULT",
  values: CONSTANTS.TONALITY,
  multiselect: false,
};

export const DATA_COUNT_LIMIT = [
  {
    label: "10",
    value: 10,
  },
  {
    label: "20",
    value: 20,
  },
  {
    label: "50",
    value: 50,
  },
  {
    label: "100",
    value: 100,
  },
  {
    label: "500",
    value: 500,
  },
  {
    label: "1000",
    value: 1000,
  },
];

export const SHARE_COUNT_LIMIT = [
  {
    label: "50",
    value: 50,
  },
  {
    label: "100",
    value: 100,
  },
  {
    label: "500",
    value: 500,
  },
  {
    label: "1000",
    value: 1000,
  },
];

export const WIDGET_TYPES = {
  FEED_WIDGET: "FW",
  REPORT_WIDGET: "RW",
};

export const WIDGET_TYPE_OPTIONS = [
  {
    name: "Feeds Widget",
    id: WIDGET_TYPES.FEED_WIDGET,
  },
  {
    name: "Reports Widget",
    id: WIDGET_TYPES.REPORT_WIDGET,
  },
];

export const DATA_TYPES = {
  NUMBER: "#",
  PERCENTAGE: "%",
  N_TEXT: "Numeric",
  P_TEXT: "Percentage",
};

export const DATA_TYPES_OPTIONS = [
  {
    id: DATA_TYPES.NUMBER,
    label: DATA_TYPES.NUMBER,
    text: DATA_TYPES.N_TEXT,
  },
  {
    id: DATA_TYPES.PERCENTAGE,
    label: DATA_TYPES.PERCENTAGE,
    text: DATA_TYPES.P_TEXT,
  },
];
